var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-row',[_c('v-col',{staticClass:"dashboard pa-0 ma-0",attrs:{"cols":"12"}},[_c('img',{staticClass:"dashboard__logo",attrs:{"src":require("./../../assets/img/global/repairs/e_r_logo_white.png"),"alt":""}})])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }